import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "overlay", "main", "collapseBtn"]

  connect() {
    if (localStorage.getItem("sidebar-collapsed") === "true") {
      this.applyCollapsed(true)
    }
  }

  toggle() {
    this.sidebarTarget.classList.toggle("-translate-x-full")
    this.overlayTarget.classList.toggle("hidden")
  }

  close() {
    this.sidebarTarget.classList.add("-translate-x-full")
    this.overlayTarget.classList.add("hidden")
  }

  collapse() {
    const collapsed = this.sidebarTarget.classList.contains("sidebar-collapsed")
    this.applyCollapsed(!collapsed)
    localStorage.setItem("sidebar-collapsed", (!collapsed).toString())
  }

  applyCollapsed(collapsed) {
    this.sidebarTarget.classList.toggle("sidebar-collapsed", collapsed)
    this.mainTarget.classList.toggle("main-content-collapsed", collapsed)
    this.mainTarget.classList.toggle("ml-72", !collapsed)
    if (this.hasCollapseBtnTarget) {
      this.collapseBtnTarget.querySelector("svg").style.transform = collapsed ? "rotate(180deg)" : ""
    }
  }
}
